import { Component } from '@angular/core';
import { CoreSignalSkillEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';

@RegisterClass(BaseFormComponent, 'Skills') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-coresignalskill-form',
    templateUrl: './coresignalskill.form.component.html'
})
export class CoreSignalSkillFormComponent extends BaseFormComponent {
    public record!: CoreSignalSkillEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true }
        ]);
    }
}

